import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { OrderByPipe } from '../../../shared/pipe/order-by.pipe';

// services
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HiringService } from '../../hiring/services/hiring.service';

@Component({
  selector: 'app-browse-jobs',
  templateUrl: './browse-jobs.component.html',
  styleUrls: ['./browse-jobs.component.css']
})

export class BrowseJobsComponent implements OnInit {
  formData: any = {};
  orderByPipe: OrderByPipe;

  jobRequisitions: any[] = [];
  pagedJobRequisitions: any[] = [];
  filterValues: any = {};
  locationFiltersLoaded: boolean = false;
  templateFiltersLoaded: boolean = false;
  companyFiltersLoaded: boolean = false;
  categoryFiltersLoaded: boolean = false;
  expandedFilter: boolean = false;
  defaultCategory: any = null;
  defaultCompany: any = null;
  customHTMLHeaderOnCareersSafeHtml: SafeHtml;
  showRequisitionNumberOnExternalATSPosting: boolean = false;
  hideCategoryFromCareersPage: boolean = false;
  hideCareerFilter: boolean = false;
  browseJobsColor: boolean = false;
  portalSettings: any = {};
  locationFilters: LocationFilter[] = [];
  companyFilters: Filter[] = [];
  templateFilters: Filter[] = [];
  groupedLocations: { [key: string]: LocationFilter[] } = {};
  categoryFilters: Filter[] = [];
  oNLogoCo: any;
  logoUrl: string;

  constructor(portalSettingsService: PortalSettingsService, private hiringService: HiringService, private sanitizer: DomSanitizer,
    private router: Router) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.orderByPipe = new OrderByPipe();
  }

  ngOnInit(): void {
    this.formData.itemsPerPage = 25;
    this.formData.currentPage = 1;
    this.filterValues = { searchText: null, templateIDString: null, companyString: null, categoryIDString: null, cityString: null, stateString: null };
    const customHeader = this.portalSettings.CustomeHTMLHeaderOnCareers.ConfigValue;
    this.customHTMLHeaderOnCareersSafeHtml = customHeader ? this.sanitizer.bypassSecurityTrustHtml(customHeader) : null;
    this.browseJobsColor = this.portalSettings.BrowseJobsColors.ConfigValue;
    this.showRequisitionNumberOnExternalATSPosting = this.portalSettings.ShowRequisitionNumberOnExternalATSPosting.ConfigValue == '1';
    this.hideCategoryFromCareersPage = this.portalSettings.HideCategoryFromCareersPage.ConfigValue == '1';
    this.hideCareerFilter = this.portalSettings.HideCareerFilter.ConfigValue == '1';
    this.oNLogoCo = this.portalSettings.OnboardingLogoCo.ConfigValue;
    this.logoUrl = "/Company/GetLogo?co=" + this.oNLogoCo + "&size=L";
    this.getRouteData();
    this.getLocationFilter();
    this.getCompanyFilter();
    this.getTemplateFilter();
    this.getCategoryFilter();
  }

  searchJobsEvent(event: any) {
    if (event == null || (event != null && event.keyCode == 13))
      this.searchJobs();
  }

  searchJobs() {
    var requestParams = "";
    if (this.filterValues.searchText != null && this.filterValues.searchText != "")
      requestParams += "?searchText=" + this.filterValues.searchText;
    if (this.filterValues.templateIDString != null && this.filterValues.templateIDString != "") {
      requestParams += requestParams.length > 1 ? "&" : "?";
      requestParams += "templateIDString=" + this.filterValues.templateIDString;
    }
    if (this.filterValues.companyString != null && this.filterValues.companyString != "") {
      requestParams += requestParams.length > 1 ? "&" : "?";
      requestParams += "companyString=" + this.filterValues.companyString;
    }
    if (this.filterValues.categoryIDString != null && this.filterValues.categoryIDString != "") {
      requestParams += requestParams.length > 1 ? "&" : "?";
      requestParams += "categoryIDString=" + this.filterValues.categoryIDString;
    }
    if (this.filterValues.cityString != null && this.filterValues.cityString != "") {
      requestParams += requestParams.length > 1 ? "&" : "?";
      requestParams += "cityString=" + this.filterValues.cityString;
    }
    if (this.filterValues.stateString != null && this.filterValues.stateString != "") {
      requestParams += requestParams.length > 1 ? "&" : "?";
      requestParams += "stateString=" + this.filterValues.stateString;
    }

    this.hiringService.getJobReqSearchExternal(requestParams).then((response: any[]) => {
      if (response != null) {
        this.jobRequisitions = response;
        this.jobRequisitions = this.orderByPipe.transform(this.jobRequisitions, ["DatePosted"], "desc");
        this.updateFilteredDocuments();
      }
    });
  }

  updateFilteredDocuments() {
    var begin = ((this.formData.currentPage - 1) * this.formData.itemsPerPage);
    var end = begin + this.formData.itemsPerPage;
    this.pagedJobRequisitions = this.jobRequisitions.slice(begin, end);
  }

  updateShowCity(data: any) {
    data.showCity = !data.showCity;
  }

  removeAllFilters() {
    this.filterValues.searchText = null;
    for (var key in this.groupedLocations) {
      this.groupedLocations[key].forEach((val: any) => {
        val.IsCitySelected = false;
        val.IsStateSelected = false;
      });
    }

    if (this.templateFilters?.length > 0) {
      this.templateFilters.forEach((val: any) => {
        val.IsSelected = false;
      });
    }

    if (this.companyFilters?.length > 0) {
      this.companyFilters.forEach((val: any) => {
        val.IsSelected = false;
      });
    }
    if (this.categoryFilters?.length > 0) {
      this.categoryFilters.forEach((val: any) => {
        val.IsSelected = false;
      });
    }

    this.updateFilteredJobs();
  }

  stateFilterChanged(filterByState: any[]) {
    if (filterByState?.length > 0) {
      filterByState.forEach((val: any) => {
        val.IsCitySelected = filterByState[0].IsStateSelected;
      });
      if (filterByState[0].IsCitySelected)
        filterByState[0].showCity = true;
    }
    this.updateFilteredJobs();
  }

  cityFilterChanged(filterByState: any[]) {
    if (filterByState) {
      var isStateSelected = true;
      isStateSelected = filterByState.every(item => item.IsCitySelected);
      filterByState[0].IsStateSelected = isStateSelected;
      this.updateFilteredJobs();
    }
  }

  public updateFilteredJobs(): void {
    const selectedCategories = this.getSelectedCategories();
    const selectedTemplates = this.getSelectedTemplates();
    const [selectedCities, selectedStates] = this.getSelectedCitiesAndStates();
    const selectedCompanies = this.getSelectedCompanies();
    this.updateCompanyLogo(selectedCompanies);

    sessionStorage.setItem("ATBrowseCityFilter", JSON.stringify(selectedCities));
    sessionStorage.setItem("ATBrowseTemplateFilter", JSON.stringify(selectedTemplates));
    sessionStorage.setItem("ATBrowseCompanyFilter", JSON.stringify(selectedCompanies));
    sessionStorage.setItem("ATBrowseCategoryFilter", JSON.stringify(selectedCategories));

    this.filterValues.stateString = selectedStates.join(",");
    this.filterValues.cityString = selectedCities.join(",");
    this.filterValues.templateIDString = selectedTemplates.join(",");
    this.filterValues.companyString = selectedCompanies.join(",");
    this.filterValues.categoryIDString = selectedCategories.join(",");

    this.searchJobs();
  }

  goToJobDetail (job: any) {
    this.router.navigate(['/careers/jobdetails', job.ReqID], { queryParams: { openModal: 'N', logoUrl: this.logoUrl } });
  }

  private getSelectedCategories (): number[] {
    const selectedCategories = [];
    if (this.categoryFilters?.length > 0) {
      this.categoryFilters.forEach((filter: Filter) => {
        if (filter.IsSelected && selectedCategories.indexOf(filter.FieldValue) === -1)
          selectedCategories.push(filter.FieldValue);
      });
    }
    return selectedCategories;
  }

  private getSelectedTemplates (): number[] {
    const selectedTemplates = [];
    if (this.templateFilters?.length > 0) {
      this.templateFilters.forEach((filter: Filter) => {
        if (filter.IsSelected && selectedTemplates.indexOf(filter.FieldValue) === -1) {
          selectedTemplates.push(filter.FieldValue);
        }
      });
    }
    return selectedTemplates;
  }

  private getSelectedCitiesAndStates (): [string[], string[]] {
    const selectedCities: string[] = [];
    const selectedStates: string[] = [];
    const states = Object.keys(this.groupedLocations);

    if (states.length > 0) {
      states.forEach((state: string) => {
        let count = 0;
        let locations: LocationFilter[] = this.groupedLocations[state];
        locations.forEach((location: LocationFilter) => {
          if (location.IsCitySelected) {
            selectedCities.push(location.CityValue);
            count++;
          }
        })
        if (count > 0 && selectedStates.indexOf(locations[0].StateFieldValue) == -1) {
          selectedStates.push(locations[0].StateFieldValue);
        }
      });
    }
    return [selectedCities, selectedStates];
  }

  private getSelectedCompanies (): number[] {
    const selectedCompanies = []
    if (this.companyFilters?.length > 0) {
      this.companyFilters.forEach((filter: Filter) => {
        if (filter.IsSelected && !selectedCompanies.includes(filter.FieldValue)) {
          selectedCompanies.push(filter.FieldValue);
        }
      });
    }
    return selectedCompanies
  }

  private updateCompanyLogo (selectedCompanies: number[]): void {
    const enterpriseWide = -1;
    if (selectedCompanies.length !== 1 || selectedCompanies[0] === enterpriseWide) {
      this.setLogoUrl(this.oNLogoCo);
    } else {
      this.setLogoUrl(selectedCompanies[0]);
    }
  }

  private setLogoUrl (companyID: number): void {
    this.logoUrl = "/Company/GetLogo?co=" + companyID + "&size=L";
  }

  private getRouteData() {
    //Route data
    var path = window.location.hash;
    if (path != null && path.length > 1) {
      var routeRegex = /^#[/]Category[=](\d+([,]?\d+)*)?(?:[/]Company[=]([-]?\d+([,]?[-]?\d+)*))?$/i;
      var routeMatch = routeRegex.exec(path);
      if (routeMatch != null) {
        this.defaultCategory = routeMatch[1];
        if (routeMatch[3] != null)
          this.defaultCompany = routeMatch[3];
      }
    }
  }

  private getLocationFilter() {
    this.hiringService.getLocationFilter().then((response: any[]) => {
      if (response != null) {
        this.locationFilters = response;
        this.groupLocationFilters();
      }
    });
  }

   private getCompanyFilter() {
    this.companyFilters = [];
    this.hiringService.getReqFilterChoices('company').then((response: any[]) => {
      if (response != null) {
        this.companyFilters = response;
        var tempList: any[] = [];
        tempList = this.defaultCompany != null ? this.defaultCompany.split(',') : null;

        var storedCompanyFilter = [];
        if (sessionStorage.getItem("ATBrowseCompanyFilter") != null && sessionStorage.getItem("ATBrowseCompanyFilter") != "") {
          storedCompanyFilter = JSON.parse(sessionStorage.getItem("ATBrowseCompanyFilter"));
        }

        if (this.companyFilters?.length > 0) {
          this.companyFilters.forEach((val: any) => {
            if (this.defaultCompany == null) {
              if (storedCompanyFilter.indexOf(val.FieldValue) > -1) {
                val.IsSelected = true;
              }
            }

            if (tempList != null) {
              tempList.forEach((defaultCompanyVal: any) => {
                if (parseInt(defaultCompanyVal) == val.FieldValue) {
                  val.IsSelected = true;
                }
              });
            }
          });
        }

        this.companyFiltersLoaded = true;
        if (this.locationFiltersLoaded && this.templateFiltersLoaded && this.categoryFiltersLoaded && this.companyFiltersLoaded) {
          this.updateFilteredJobs();
        }
      }
    });
  }

  private groupLocationFilters() {
    let storedCityFilter: any[] = [];
    if (sessionStorage.getItem("ATBrowseCityFilter")) {
      storedCityFilter = JSON.parse(sessionStorage.getItem("ATBrowseCityFilter"));
    }

    if (this.locationFilters?.length > 0) {
      this.locationFilters.forEach((filter: any) => {
        if (!this.groupedLocations[filter.StateFieldValue]) {
          this.groupedLocations[filter.StateFieldValue] = [];
        }
        if (storedCityFilter.indexOf(filter.CityValue) > -1) {
          filter.IsCitySelected = true;
        }
        this.groupedLocations[filter.StateFieldValue].push(filter);
      });
    }

    Object.entries(this.groupedLocations).forEach(([key, val]) => {
      var count = val.filter((item: any) => item.IsCitySelected).length;
      if (count === val.length) {
        val[0].IsStateSelected = true;
      }
    });

    this.locationFiltersLoaded = true;
    if (this.locationFiltersLoaded && this.templateFiltersLoaded && this.categoryFiltersLoaded && this.companyFiltersLoaded) {
      this.updateFilteredJobs();
    }
  }


  private getTemplateFilter() {
    this.hiringService.getReqFilterChoices('template').then((response: any[]) => {
      if (response != null) {
        this.templateFilters = response;

        var storedTemplateFilter = [];
        if (sessionStorage.getItem("ATBrowseTemplateFilter") != null && sessionStorage.getItem("ATBrowseTemplateFilter") != "") {
          storedTemplateFilter = JSON.parse(sessionStorage.getItem("ATBrowseTemplateFilter"));
        }

        if (this.templateFilters?.length > 0) {
          this.templateFilters.forEach((val: any) => {
            if (storedTemplateFilter.indexOf(val.FieldValue) > -1) {
              val.IsSelected = true;
            }
          });

          this.templateFiltersLoaded = true;
          if (this.locationFiltersLoaded && this.templateFiltersLoaded && this.categoryFiltersLoaded && this.companyFiltersLoaded)
            this.updateFilteredJobs();
        }
      }
    });
  }

  private getCategoryFilter() {
    this.hiringService.getReqFilterChoices('category').then((response: any[]) => {
      if (response != null) {
        this.categoryFilters = response;
      }
    });

    var tempList = [];
    tempList = this.defaultCategory != null ? this.defaultCategory.split(',') : null;

    var storedCategoryFilter = [];
    if (sessionStorage.getItem("ATBrowseCategoryFilter") != null && sessionStorage.getItem("ATBrowseCategoryFilter") != "") {
      storedCategoryFilter = JSON.parse(sessionStorage.getItem("ATBrowseCategoryFilter"));
    }

    if (this.categoryFilters?.length > 0) {
      this.categoryFilters.forEach((val: any) => {
        if (this.defaultCategory == null) {
          if (storedCategoryFilter.indexOf(val.FieldValue) > -1) {
            val.IsSelected = true;
          }
        }
        if (tempList != null) {
          tempList.forEach((defaultCategoryVal: any) => {
            if (parseInt(defaultCategoryVal) == val.FieldValue) {
              val.IsSelected = true;
            }
          });
        }
      });
    }

    this.categoryFiltersLoaded = true;
    if (this.locationFiltersLoaded && this.templateFiltersLoaded && this.categoryFiltersLoaded && this.companyFiltersLoaded)
      this.updateFilteredJobs();
  }
}

export interface Filter {
  DisplayValue: string;
  FieldValue: number;
  RecordCount: number;
  ShowInFilter: boolean;
  IsSelected: boolean;
}

export interface LocationFilter {
  CityValue: string;
  RecordCount: number;
  StateDisplayValue: string;
  StateFieldValue: string;
  IsCitySelected: boolean;
  IsStateSelected: boolean
}
